// IE 2026 09 30 / ODOO-343435: вход в guided-тур ссылкой — #/<база>?guide_path=<id пути>&step=<n> (письмо, сайт, QR на стенде).
// router.beforeEach кладёт ссылку в store.guideLink_fromURL (guideLink_fromQuery: ключи guide_path / step из query УДАЛЯЮТСЯ — как open_record,
// иначе ключ страницы App.routeViewKey менялся бы); забирают её workspace_show_widgets (стол строится) и workspace_activate (стол уже открыт):
// guideLink_take — пауза, затем store.guide_play(null, {id, step}) (тот же показ, что «Start path»). Выключатель — fe.guide.tour: выключен —
// ссылка молча игнорируется (стол открывается как обычно). Модуль без внешних импортов, кроме соседних utils (юнит: tests/unit/guideLink.test.mjs).
// IE 2026 10 09 / ODOO-343435 (живая проверка dev02: гость без сессии): ссылка в сторе до стола не доживает — login делает store.$reset() (guideLink_fromURL
// объявлен в state), а первый вход в браузере ещё и перезагружает страницу на язык базы (i18n reloadNow: location.reload()). Поэтому router.beforeEach
// ещё и ЗАПОМИНАЕТ ссылку в sessionStorage вкладки (guideLink_keep: id, step, база, время), в том числе на форме входа; когда стол открыт, а в сторе
// ссылки нет, guideLink_take берёт её оттуда (guideLink_pending): своя база и не старше 30 мин, иначе запись снимается. Забранная ссылка снимается.
// На форме входа тур не стартует: забирают только workspace_show_widgets / workspace_activate (стол).
import { guideCases_tourOn, guideCases_count } from './guideCases.js'

export const GUIDE_LINK_DELAY = 1500   // стол строится: показ после старта виджетов страницы (как ссылка open_record)
export const GUIDE_LINK_ID_MAX = 200   // как MARK_ID_MAX бэка: длинный id — не ссылка на путь
export const GUIDE_LINK_KEY = 'fe.guide.link'          // IE 2026 10 09 / ODOO-343435: sessionStorage вкладки — ссылка, ждущая стола (одна на вкладку, последняя главнее)
export const GUIDE_LINK_TTL = 30 * 60 * 1000           // IE 2026 10 09 / ODOO-343435: запомненная ссылка старше — устарела (гость ушёл от формы входа)

// ссылка из query маршрута: { id, step } или null; ключи guide_path / step удаляются только вместе с guide_path
export function guideLink_fromQuery(query) {
    if (!query || !query.guide_path) return null
    const id = String(Array.isArray(query.guide_path) ? query.guide_path[0] : query.guide_path).trim()
    const n = parseInt(Array.isArray(query.step) ? query.step[0] : query.step, 10)
    delete query.guide_path
    delete query.step
    if (!id || id.length > GUIDE_LINK_ID_MAX || !/^[\w.:-]+$/.test(id)) return null
    return { id, step: Number.isFinite(n) && n > 0 ? n : null }
}

// IE 2026 10 09 / ODOO-343435: хранилище вкладки — sessionStorage (opts.storage — тест); недоступно (приватный режим, запрет) → null, работа как раньше
function guideLink_storage(opts = {}) {
    try { return opts.storage || (typeof sessionStorage !== 'undefined' ? sessionStorage : null) } catch (e) { return null }
}

// IE 2026 10 09 / ODOO-343435: запомнить ссылку, ждущую стола: { id, step } + база адреса (to.params.dbid, у /login без базы — '') + время.
// Пустая ссылка (мусор в адресе) снимает прежнюю: последняя ссылка главнее. true — записано
export function guideLink_keep(link, dbid = '', opts = {}) {
    const st = guideLink_storage(opts)
    if (!st) return false
    try {
        if (!link || !link.id) { st.removeItem(GUIDE_LINK_KEY); return false }
        st.setItem(GUIDE_LINK_KEY, JSON.stringify({ id: link.id, step: link.step || null, db: String(dbid || ''), at: (opts.now || Date.now)() }))
        return true
    } catch (e) { return false }
}

// IE 2026 10 09 / ODOO-343435: снять запомненную ссылку (забрана / выключен тур / устарела / чужая база)
export function guideLink_forget(opts = {}) {
    const st = guideLink_storage(opts)
    try { if (st) st.removeItem(GUIDE_LINK_KEY) } catch (e) { /* хранилище недоступно */ }
}

// IE 2026 10 09 / ODOO-343435: запомненная ссылка для открытого стола базы dbid: { id, step } или null. Снимает запись, если она испорчена, старше
// GUIDE_LINK_TTL или сделана для другой базы (база адреса и база стола известны обе; не известна одна — не сравниваются)
export function guideLink_pending(dbid = '', opts = {}) {
    const st = guideLink_storage(opts)
    if (!st) return null
    try {
        const raw = st.getItem(GUIDE_LINK_KEY)
        if (!raw) return null
        let rec = null
        try { rec = JSON.parse(raw) } catch (e) { rec = null }
        const id = rec && typeof rec.id === 'string' ? rec.id : ''
        const age = Math.abs((opts.now || Date.now)() - Number(rec && rec.at))
        const ok = id && id.length <= GUIDE_LINK_ID_MAX && /^[\w.:-]+$/.test(id) && age <= GUIDE_LINK_TTL && !(rec.db && dbid && rec.db !== dbid)
        if (!ok) { st.removeItem(GUIDE_LINK_KEY); return null }
        const n = Number(rec.step)
        return { id, step: Number.isFinite(n) && n > 0 ? n : null }
    } catch (e) { return null }
}

// ссылка на тур для «Copy link» / письма: база обязательна
export function guideLink_url(store, id, step = null, loc = null) {
    const dbid = store?.user?.database?.dbid || ''
    const l = loc || (typeof window !== 'undefined' ? window.location : { origin: '', pathname: '/' })
    if (!id || !dbid) return ''
    return `${l.origin}${l.pathname}#/${dbid}?guide_path=${encodeURIComponent(String(id))}${step ? `&step=${Number(step)}` : ''}`
}

// забрать ссылку и начать показ; true — забрана (показ запланирован). opts: delay, win, setTimeout (тест); IE 2026 10 09 / ODOO-343435: + storage, now (тест)
export function guideLink_take(store, opts = {}) {
    // IE 2026 10 09 / ODOO-343435: в сторе ссылки нет (login: store.$reset(); первый вход: перезагрузка на язык базы) — берём запомненную вкладкой
    let link = store && store.guideLink_fromURL
    if (store && (!link || !link.id)) link = guideLink_pending(store.user?.database?.dbid || '', opts)
    if (!link || !link.id) return false
    store.guideLink_fromURL = null
    guideLink_forget(opts)   // IE 2026 10 09 / ODOO-343435: забрана — запомненная копия своё отработала (иначе вторая страница стола запустила бы тур снова)
    if (!guideCases_tourOn(store)) return false
    const delay = opts.delay ?? GUIDE_LINK_DELAY
    const run = () => {
        guideCases_count('tourLinks')
        try { store.guide_play(null, { id: link.id, ...(link.step ? { step: link.step } : {}) }) } catch (e) { console.warn('guide_path link ignored:', e) }
    }
    const st = opts.setTimeout || setTimeout
    st(run, delay)
    const win = opts.win || globalThis.window
    try {
        const href = String((win && win.location && win.location.href) || '')
        if (href.includes('guide_path=')) win.history.replaceState(win.history.state, '', href.replace(/[?&](guide_path|step)=[^&]*/g, (m) => (m[0] === '?' ? '?' : '')).replace(/\?&/, '?').replace(/\?$/, ''))
    } catch (e) { /* адрес оставляем как есть */ }
    return true
}

export default { GUIDE_LINK_DELAY, GUIDE_LINK_ID_MAX, GUIDE_LINK_KEY, GUIDE_LINK_TTL, guideLink_fromQuery, guideLink_keep, guideLink_forget, guideLink_pending, guideLink_url, guideLink_take }   // IE 2026 10 09 / ODOO-343435
